import { Grid } from "@mui/material";
import {
  OutputScenarioContainer,
  StickyContainer,
} from "./ScenarioResult.Styled";
import { ResultFilters } from "./components/ResultFilters/ResultFilters";
import { ScenarioOverview } from "./components/ScenarioOverview/ScenarioOverview";

const ScenarioResult = () => {
  return (
    <Grid style={{ margin: "0 auto" }}>
      <OutputScenarioContainer>
        <StickyContainer>
          <ResultFilters />
        </StickyContainer>
        <ScenarioOverview />
      </OutputScenarioContainer>
    </Grid>
  );
};

export default ScenarioResult;
